module.exports = __webpack_public_path__ + "img/wx-img3.78e64dd8.png";